import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box';
import { Button, TextField, Typography } from '@mui/material';
import VendorRFormstyles from './VendorRForm.module.css';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import axios from 'axios';
import { json } from 'react-router-dom';

function VendorRForm() {

    const [checkData, setCheckData] = useState([]);

    const getData = async () => {

        try {
            const res = await axios.get(`${process.env.REACT_APP_STEELADMIN}/form/GetAllFormCheck`).then((res) => {

                setCheckData(res.data.map(((data) => {

                    let per = JSON.parse(data.permission);

                    return {
                        ...data,
                        permission: per
                    }
                })));

                
            })
        } catch (error) {
            console.log(error)
        }

    }

    useEffect(() => {
        getData();
    }, [])

    const handleCheckBox = (id, permissionId) => {
        console.log(id, "dsadsa", permissionId)
        setCheckData((prev) => {
            const updatedData = prev.map((dd) => {
                if (dd.id === id) {
                    return {
                        ...dd,
                        permission: {
                            ...dd.permission,
                            [permissionId]: !dd.permission[permissionId],
                        },
                    };
                }
                return dd;
            });

            return updatedData;
        });

       
    }

   
    const handelSubmit = () => {


        
        const convertedData = checkData.map((item) => {

            if (typeof item.permission === "object" && !Array.isArray(item.permission)) {

                item.permission = Object.values(item.permission);
            }
            return item;
        });

        
        try {


            const res = axios.post(`${process.env.REACT_APP_STEELADMIN}/form/setForm`, convertedData).then((res) => {
                setCheckData(res.data.map(((data) => {

                    let per = JSON.parse(data.permission);

                    return {
                        ...data,
                        permission: per
                    }
                })));
            })
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <div className={VendorRFormstyles.mainDiv}>

            <Box className={VendorRFormstyles.mainDivStart}>
                <form action="">
                    {/* <Box>
                    <Typography variant='h1'>
                        Vendor registration form
                    </Typography>
                    <Typography variant='h2'>Personal Details</Typography>

                    <Box className={VendorRFormstyles.Rolecheck}>
                        <label>Name </label>
                        <FormGroup className={VendorRFormstyles.RolesCheckGroup} >
                            <FormControlLabel
                                control={<Checkbox />}
                                label={<Typography className={VendorRFormstyles.newOne}>Mandatory field</Typography>} />

                            <FormControlLabel
                                control={<Checkbox />}
                                label={<Typography className={VendorRFormstyles.newOne}>display on website</Typography>} />
                        </FormGroup>
                    </Box>
                    <Box className={VendorRFormstyles.Rolecheck}>
                        <label>Email</label>
                        <FormGroup className={VendorRFormstyles.RolesCheckGroup} >
                            <FormControlLabel
                                control={<Checkbox />}
                                label={<Typography className={VendorRFormstyles.newOne}>Mandatory field</Typography>} />

                            <FormControlLabel
                                control={<Checkbox />}
                                label={<Typography className={VendorRFormstyles.newOne}>display on website</Typography>} />
                        </FormGroup>
                    </Box>
                    <Box className={VendorRFormstyles.Rolecheck}>
                        <label>Phone</label>
                        <FormGroup className={VendorRFormstyles.RolesCheckGroup} >
                            <FormControlLabel
                                control={<Checkbox />}
                                label={<Typography className={VendorRFormstyles.newOne}>Mandatory field</Typography>} />

                            <FormControlLabel
                                control={<Checkbox />}
                                label={<Typography className={VendorRFormstyles.newOne}>display on website</Typography>} />
                        </FormGroup>
                    </Box>
                    <Box className={VendorRFormstyles.Rolecheck}>
                        <label>Country</label>
                        <FormGroup className={VendorRFormstyles.RolesCheckGroup} >
                            <FormControlLabel
                                control={<Checkbox />}
                                label={<Typography className={VendorRFormstyles.newOne}>Mandatory field</Typography>} />

                            <FormControlLabel
                                control={<Checkbox />}
                                label={<Typography className={VendorRFormstyles.newOne}>display on website</Typography>} />
                        </FormGroup>
                    </Box>

                </Box> */}

                    <Box>
                        <Typography variant='h2'>Business Details</Typography>

                        {checkData.map((data) => {
                            return (
                                <Box className={VendorRFormstyles.Rolecheck} key={data.id}>
                                    <label>{data.name} </label>
                                    <FormGroup className={VendorRFormstyles.RolesCheckGroup} >
                                        <FormControlLabel
                                            control={<Checkbox checked={data.permission[1]} onChange={() => handleCheckBox(data.id, 1)} />}
                                            label={<Typography className={VendorRFormstyles.newOne}>Mandatory field</Typography>} />

                                        <FormControlLabel
                                            control={<Checkbox checked={data.permission[0]} onChange={() => handleCheckBox(data.id, 0)} />}
                                            label={<Typography className={VendorRFormstyles.newOne}>display on website</Typography>} />
                                    </FormGroup>
                                </Box>
                            )

                        })}


                        <Box className={VendorRFormstyles.RoleButton}>
                            <Button onClick={handelSubmit} variant='contained' className={VendorRFormstyles.saveButton}>Save changes</Button>
                        </Box>


                    </Box>
                </form>
            </Box>
        </div>
    )
}

export default VendorRForm